import React from "react";
import { FiMail, FiPhoneCall } from "react-icons/fi";
import ContactForm from "./components/contact-form";

export default function ContactPageWrapper() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="mx-auto grid w-[92%] max-w-[1100px] items-start gap-12 py-16 lg:grid-cols-[1fr_1.1fr] lg:py-24">
      <div className="space-y-6">
        <span className="inline-flex rounded-full bg-secondary-dark/15 px-3.5 py-1 text-[13px] font-semibold text-[#9a6f08]">
          Contact
        </span>
        <h1 className="text-4xl font-extrabold tracking-tight text-primary-dark lg:text-5xl">Get in touch with us</h1>
        <p className="max-w-[460px] text-lg leading-relaxed text-[#5b5f73]">
          Questions about vending, gate pass or getting a meter? Send us a message and we’ll get back to you.
        </p>
        <ul className="space-y-4 pt-2">
          <li className="flex items-center gap-3 text-[#2a2e45]">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary-dark text-secondary-dark"><FiMail /></span>
            prepaidnigeria@gmail.com
          </li>
          <li className="flex items-center gap-3 text-[#2a2e45]">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary-dark text-secondary-dark"><FiPhoneCall /></span>
            +234-906-882-5492
          </li>
        </ul>
      </div>
      <ContactForm />
    </section>
  );
}
